import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: () =>
            import ('../pages/index.vue'),
    }, {
      path: '/index',
      name: '',
      component: () =>
        import ('../pages/index.vue'),
    }, {
        path: '/form',
        name: '',
        component: () =>
            import ('../pages/form.vue'),
    }, {
        path: '/amza',
        name: '',
        component: () =>
            import ('../pages/amazon-a.vue'),
    }, {
        path: '/amzb',
        name: '',
        component: () =>
            import ('../pages/amazon-b.vue'),
    }, {
        path: '/join',
        name: '',
        component: () =>
            import ('../pages/join.vue'),
    }, {
        path: '/upload',
        name: '',
        component: () =>
            import ('../pages/upload.vue'),
    }, {
        path: '/review',
        name: '',
        component: () =>
            import ('../pages/review.vue'),
    }, {
        path: '/thanks',
        name: '',
        component: () =>
            import ('../pages/thanks.vue'),
    },
      /* contact-us */
      {
        path: '/contact-us',
        name: '',
        component: () =>
          import ('../pages/contact-us/index.vue'),
      },
      {
        path: '/pre-sales-inquiry',
        name: '',
        component: () =>
          import ('../pages/contact-us/pre-sales-inquiry.vue'),
      },
      {
        path: '/after-sales-inquiry',
        name: '',
        component: () =>
          import ('../pages/contact-us/after-sales-inquiry.vue'),
      },
      {
        path: '/submitted',
        name: '',
        component: () =>
          import ('../pages/contact-us/submitted.vue'),
      },
      // package-protection
      {
        path: '/package-protection-claim',
        name: 'PackageProtectionClaim',
        component: () =>
          import ('../pages/package-protection/package-protection-claim.vue'),
      }
    ]
})


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js